// @ts-nocheck
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { replaceUnderscore } from "../../../../../CommonFunction/common";
import { ClearSpecificForm } from "../../../../../Store/FormDataReducer/FormFieldFunctions";
import { checkFormErrors } from "../../../../custom_hooks/useCheckFormError";
import PortalFooter from "../../../Reactportal/PortalFooter";
import Reactportal from "../../../Reactportal/Reactportal";
// import { AddMeterialItems } from "../AddConsignmentNoteConfig";
import AddMeterialDetails from "../InvoiceAndItemTable/AddMeterial";
import "./AddItems.scss";
import { useModalContext } from "../../../Reactportal/ModalContext";
import { useEventListener } from "usehooks-ts";
import { FormInputSectionComponent } from "../../../FormInputSectionComponent/FormInputSectionComponent";
import { updateSingleField, updateValueForm } from "../../../FormInputSectionComponent/formUtils";
import { getFormSectionsAndFields } from "../../../../../Utils/AllPagesQuriesAndMutations";
import { useLazyQuery } from "@apollo/client";
import Button from "../../../Button/Button";
import MultiPartNameSelectModal from "./MultiPartNameSelectModal";

const AddItems = ({ show, setItems, setShowModal, itemConfig, editData, index, Parent_Form_Key, priceListData, TypeOfPortal }) => {
  const [openItems, setOpenItems] = useState(show);
  const dispatch = useDispatch();
  const [InputFields, setInputFields] = useState([]);
  const [isFirstLoad, setFirstLoad] = useState(false);
  const [openPartNameModal, setOpenPartNameModal] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [partNameData, setPartNameData] = useState([])
  const { pushModal, popModal, getTopModal } = useModalContext();
  const [FormData, setFormdata] = useState({});
  const formRef = useRef({});
  const FormDataFromRedux = useSelector((store: any) => store?.FormDataReducer);
  const Form_Key = Parent_Form_Key === "Consignment_Note" ? "PTL_CN_Items" : "FTL_CN_Items";

  const [getFormSectionAndFields, { loading: getFormSectionAndFieldsLoading }] = useLazyQuery(
    getFormSectionsAndFields,
    {
      variables: {
        key: Form_Key,
      },
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        setInputFields(data?.formSectionAndFields);
      },
    }
  );

  useEffect(() => {
    getFormSectionAndFields();
  }, []);

  useEffect(() => {
    pushModal(Form_Key);
    return () => {
      popModal(Form_Key);
    };
  }, []);

  const Closeformfunction2 = () => {
    setShowModal();
    setOpenItems(false);
    popModal(Form_Key);
    ClearSpecificForm(dispatch, Form_Key);
  };

  useEffect(() => {
    if (editData && InputFields.length) {
      let obj = { ...editData }
      dispatch({
        type: "StoreMasterData",
        payload: {
          formkey: Form_Key,
          data: { Packaging: obj?.Packaging_Data },
        },
      });
      obj.Packaging = obj?.Packaging_Data?.Type_Of_Packaging

      setPartNameData(obj?.Part_Data)
      updateValueForm(formRef, obj);

    }
  }, [editData, InputFields]);

  useEffect(() => {
    const shouldRunEffect =
      (TypeOfPortal === "Edit" && isFirstLoad) ||
      (TypeOfPortal !== "Edit" && Object.keys(editData).length === 0);

    if (shouldRunEffect && priceListData && InputFields.length) {
      let Rate = priceListData?.Price_List_Rates_Data?.[0]?.Rate;
      let freightOn = priceListData?.Price_List_Rates_Data?.[0]?.Freight_On;
      let CFT = priceListData?.Price_List_Data?.CFT;
      let minWgt = priceListData?.Price_List_Data?.Min_Wgt;
      console.log("innnnnnnnniiiiii")
      updateSingleField(formRef, "Rate", Rate);
      updateSingleField(formRef, "CFT_Ratio", CFT);
      updateSingleField(formRef, "Freight_On", freightOn ? freightOn : "Weight");
      updateSingleField(formRef, "Min_Weight", minWgt);
      updateSingleField(formRef, "Charge_Weight", minWgt);
    }
  }, [priceListData, InputFields, TypeOfPortal]);

  useEffect(() => {
    let partData = FormDataFromRedux?.MasterData[Form_Key]?.Packaging;
    if (partData && Object.keys(partData).length && isFirstLoad) {

      let temp = FormData;
      let partObj = {
        ...temp,
        Packaging: partData?.Type_Of_Packaging,
        Box_Dimension: partData?.Dimension || "0x0x0",
        Content: partData?.Content,
        Inc_CMS: partData?.Inc_CMS,
        Weight: partData?.Actual_Weight,
      };
      updateValueForm(formRef, partObj);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [FormDataFromRedux?.MasterData[Form_Key]?.Packaging]);

  const calculateCFT = () => {
    if (isFirstLoad) {
      if (FormData?.Box_Dimension) {
        const parts = FormData.Box_Dimension.split("x");
        if (parts.includes("")) {
          updateSingleField(formRef, "CFT", "");
          return;
        }
        const volume = parts.reduce((acc, part) => acc * Number(part), 1);
        if (FormData.Inc_CMS === "in") {
          const denominator = 12 * 12 * 12;
          updateSingleField(formRef, "CFT", (volume / denominator).toFixed(2));
        } else if (FormData.Inc_CMS === "cm") {
          updateSingleField(formRef, "CFT", (volume * 0.0000353147).toFixed(2));
        } else {
          updateSingleField(formRef, "CFT", null);
        }
      }
    }
  };

  useEffect(() => {
    calculateCFT()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [FormData?.Inc_CMS, FormData?.Box_Dimension]);

  const calculateVolumetricWeight = () => {
    if (isFirstLoad) {
      if (FormData?.No_Of_Boxes && FormData?.CFT && FormData?.CFT_Ratio) {
        const res = FormData.No_Of_Boxes * FormData.CFT * FormData.CFT_Ratio;
        updateSingleField(formRef, "Volumetric_Weight", res.toFixed(2));
      } else {
        updateSingleField(formRef, "Volumetric_Weight", null);
      }
    }
  };

  useEffect(() => {
    calculateVolumetricWeight()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [FormData?.CFT_Ratio, FormData?.No_Of_Boxes, FormData?.CFT]);

  const calculateTotalQuantity = () => {
    if (isFirstLoad) {
      if (FormData?.No_Of_Boxes && FormData?.Quantity_Per_Box) {
        const res = FormData.No_Of_Boxes * FormData.Quantity_Per_Box;
        updateSingleField(formRef, "Total_Quantity", res);
      } else {
        updateSingleField(formRef, "Total_Quantity", null);
      }
    }
  };

  useEffect(() => {
    calculateTotalQuantity()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [FormData?.Quantity_Per_Box, FormData?.No_Of_Boxes]);

  const calculateActualWeight = () => {
    if (isFirstLoad) {
      if (FormData?.No_Of_Boxes && FormData?.Weight) {
        const res = FormData.No_Of_Boxes * FormData.Weight;
        updateSingleField(formRef, "Actual_Weight", res.toFixed(2));
      } else {
        updateSingleField(formRef, "Actual_Weight", null);
      }
    }

  };

  useEffect(() => {
    calculateActualWeight()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [FormData?.No_Of_Boxes, FormData?.Weight]);

  const calculateChargeWeight = () => {
    if (isFirstLoad) {
      if ((FormData?.Volumetric_Weight || FormData?.Actual_Weight || FormData?.Min_Weight)) {
        const volumetricWeight = Number(FormData?.Volumetric_Weight ?? 0);
        const actualWeight = Number(FormData?.Actual_Weight ?? 0);
        const minWeight = Number(FormData?.Min_Weight ?? 0);
        const res = Math.max(volumetricWeight, actualWeight, minWeight) || 0;
        updateSingleField(formRef, "Charge_Weight", res);
      } else {
        updateSingleField(formRef, "Charge_Weight", null);
      }
    }
  };

  useEffect(() => {
    calculateChargeWeight()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [FormData?.Volumetric_Weight, FormData?.Actual_Weight, FormData?.Min_Weight]);

  const calculateFreightAmount = () => {
    if (isFirstLoad) {
      if (FormData?.Rate && FormData?.Freight_On) {
        let total = 0;
        if (FormData.Freight_On === "Weight") {
          total = Number(FormData?.Charge_Weight) * Number(FormData?.Rate);
        } else if (FormData.Freight_On === "Quantity") {
          total = Number(FormData?.Total_Quantity) * Number(FormData?.Rate);
        } else if (FormData.Freight_On === "Per Article") {
          total = Number(FormData?.No_Of_Boxes) * Number(FormData?.Rate);
        } else if (FormData.Freight_On === "Fixed") {
          total = Number(FormData?.Rate);
        }

        const minAmount = priceListData?.Price_List_Data?.Min_Amount;
        updateSingleField(formRef, "Freight_Amount", Number(Math.max(minAmount ?? 0, total).toFixed(2)));
      } else {
        updateSingleField(formRef, "Freight_Amount", null);
      }
    }
  };

  useEffect(() => {
    calculateFreightAmount()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    FormData?.No_Of_Boxes,
    FormData?.Freight_On,
    FormData?.Rate,
    FormData?.Charge_Weight,
    FormData?.Rate,
    FormData?.Total_Quantity,
  ]);

  const handleErrorsChange = (newErrors) => {
    setFormErrors((currentErrors) => ({
      ...currentErrors,
      ...newErrors,
    }));
  };

  const HanldeChangeonForm = (values) => {
    setFormdata((prev) => ({
      ...prev,
      ...values,
    }));
  };

  const handleRecalculate = () => {
    calculateCFT();
    calculateVolumetricWeight();
    calculateTotalQuantity();
    calculateActualWeight();
    calculateChargeWeight();
    calculateFreightAmount();
  };

  let submit = () => {
    delete FormData?.Sidebyside;

    let obj = {
      ...FormData,
      Part_Data: partNameData,
      Content: FormData?.Content ? String(FormData?.Content) : "",
      Packaging: String(FormData?.Packaging),
      Volumetric_Weight: FormData?.Volumetric_Weight ? Number(FormData?.Volumetric_Weight) : "",
      Actual_Weight: FormData?.Actual_Weight ? Number(FormData?.Actual_Weight) : "",
      Charge_Weight: FormData?.Charge_Weight ? FormData?.Charge_Weight : "",
      Packaging_Data: FormDataFromRedux?.MasterData[Form_Key]?.Packaging,
    };
    if (editData?._id) {
      obj._id = editData?._id;
    }
    setItems(obj, index);
    Closeformfunction2();
  };

  const Validate_handleSubmit = (submit) => {
    const Error = checkFormErrors(formErrors);
    if (!Error) {
      submit();
    }
  };

  return (
    <Reactportal open={openItems} onClose={Closeformfunction2} TypeOfPortal={replaceUnderscore(Form_Key)}>
      <div className="AddItem">
        <div className="formcontainer">
          {InputFields &&
            InputFields.map((e) => {
              return (
                <div key={e.id} className="">
                  <div className="sectionHeadings">{replaceUnderscore(e.name)}</div>
                  <div className="formSection insidecontainer">
                    <FormInputSectionComponent
                      inputfields={e.fields}
                      Type={e.name}
                      onhandleFormikChange={HanldeChangeonForm}
                      validation_Schema={e?.Valid_schema}
                      onErrorsChange={(newErrors) => handleErrorsChange(newErrors)}
                      formkey={Form_Key}
                      formRef={formRef}
                      setFirstLoad={setFirstLoad}
                    />
                  </div>
                  <div className="partInputMaindiv">
                    <div className="labelPartName">Part Name</div>
                    <div>
                      <Button
                        action={() => setOpenPartNameModal(true)}
                        text="Select Part"
                        name="PartNameBtn"
                        type={""}
                        children={""}
                        disabled={""}
                      />
                    </div>
                  </div>
                  <div className="partInputMaindiv">
                    {/* <div></div> */}
                    <div>
                      <Button
                        action={() => handleRecalculate()}
                        text="Recalculate"
                        name="CalculateBtn"
                        type={""}
                        children={""}
                        disabled={""}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
        {/* <table className="PartNameTableMaindiv">
          <thead>
            <tr>
              <th>Part Name</th>
              <th>Part Number</th>
              <th>Quantity</th>
            </tr>
          </thead>
          <tbody>
            {partNameData?.map((item, index) => (
              <tr key={index}>
                <td>{item.Part_Name}</td>
                <td>{item.Part_Number}</td>
                <td>{item.Quantity}</td>
              </tr>
            ))}
          </tbody>
        </table> */}
        {openPartNameModal && <MultiPartNameSelectModal show={openPartNameModal} setOpenPartNameModal={setOpenPartNameModal} partNameData={partNameData} setPartNameData={setPartNameData} />}
      </div>
      <PortalFooter
        renderContent={() => <></>}
        disabled={false}
        Form_key={Form_Key}
        submitform={() => {
          Validate_handleSubmit(submit);
        }}
        submitType={""}
        SaveAndClose={() => {
          Validate_handleSubmit(() => {
            submit();
          });
        }}
        handleformclose={() => {
          Closeformfunction2();
          setOpenItems(false);
        }}
      />
    </Reactportal>
  );
};

export default AddItems;

// const AddItems = ({ show, setItems, setShowModal, itemConfig, editData, index }) => {
//   const [openItems, setOpenItems] = useState(show);
//   const dispatch = useDispatch();
//   // const [alldata, setalldata] = useState<any>({});
//   const [formErrors, setFormErrors] = useState({});
//   const { pushModal, popModal, getTopModal } = useModalContext();
//   const [FormData, setFormdata] = useState({});
//   const formRef = useRef({});
//   const FormDataFromRedux = useSelector((store: any) => store?.FormDataReducer);
//   const Form_Key = "Add_Items";
//   const Closeformfunction2 = () => {
//     setShowModal();
//     setOpenItems(false);
//     popModal(Form_Key);
//     ClearSpecificForm(dispatch, Form_Key);
//   };
//   useEffect(() => {
//     if (editData) {
//       updateValueForm(formRef, editData);
//       console.log(editData);
//       // setFormdata(editData);
//     }
//   }, [editData]);

//   useEffect(() => {
//     if (openItems) {
//       pushModal(Form_Key);
//     }
//   }, [openItems, Form_Key, pushModal]);

//   useEffect(() => {
//     const input = document.getElementsByName("No_Of_Boxes");
//     if (input.length > 0) {
//       input[input.length - 1].focus();
//     }
//   }, []);

//   // useEffect(() => {
//   //   if (FormDataFromRedux && FormDataFromRedux.hasOwnProperty(Form_Key)) {
//   //     setalldata(FormDataFromRedux[Form_Key]);
//   //   }
//   // }, [FormDataFromRedux]);

//   useEffect(() => {
//     let partData = FormDataFromRedux?.MasterData?.Add_Items?.Part_Name;
//     if (partData && Object.keys(partData).length) {
//       dispatch({
//         type: "StoreMasterData",
//         payload: {
//           formkey: Form_Key,
//           data: { Packaging: { ...partData.Packaging } },
//         },
//       });
//       let temp = FormData;

//       let partObj = {
//         ...temp,
//         Part_Number: partData?.Part_Number,
//         Part_Name: partData?.Part_Name,
//         Packaging: partData?.Packaging?.Type_Of_Packaging,
//         Quantity_Per_Box: partData?.Quantity_Per_Box,
//         Box_Dimension: partData?.Dimension,
//         Content: partData?.Content,
//         Inc_CMS: partData?.Inc_CMS,
//         Weight: partData?.Weight,
//       };
//       updateValueForm(formRef, partObj);
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [FormDataFromRedux?.MasterData?.Add_Items?.Part_Name]);

//   useEffect(() => {
//     if (FormData?.Box_Dimension && FormData?.Inc_CMS === "in") {
//       let parts = FormData.Box_Dimension.split("x");
//       if (parts?.includes("")) {
//         updateSingleField(formRef, "CFT", "");
//       } else {
//         let numerator = parts.reduce((acc, part) => {
//           return acc * Number(part);
//         }, 1);
//         let denominator = 12 * 12 * 12;
//         let res = numerator / denominator;
//         updateSingleField(formRef, "CFT", res.toFixed(2));
//       }
//     } else if (FormData?.Box_Dimension && FormData?.Inc_CMS === "cm") {
//       let parts = FormData.Box_Dimension.split("x");
//       if (parts?.includes("")) {
//         updateSingleField(formRef, "CFT", "");
//       } else {
//         let numerator = parts.reduce((acc, part) => {
//           return acc * Number(part);
//         }, 1);
//         let res = numerator * 0.0000353147;
//         updateSingleField(formRef, "CFT", res.toFixed(2));
//       }
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [FormData?.Inc_CMS, FormData?.Box_Dimension]);

//   useEffect(() => {
//     if (FormData?.CFT_Ratio && FormData?.No_Of_Boxes && FormData?.CFT) {
//       if (FormData?.No_Of_Boxes && FormData?.CFT) {
//         let res = FormData?.No_Of_Boxes * FormData?.CFT * FormData?.CFT_Ratio;
//         updateSingleField(formRef, "Volumetric_Weight", res.toFixed(2));
//       }
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [FormData?.CFT_Ratio, FormData?.No_Of_Boxes, FormData?.CFT]);

//   useEffect(() => {
//     if (FormData?.No_Of_Boxes && FormData?.Quantity_Per_Box) {
//       let res = FormData?.No_Of_Boxes * FormData?.Quantity_Per_Box;
//       updateSingleField(formRef, "Total_Quantity", res);
//     } else {
//       updateSingleField(formRef, "Total_Quantity", null);
//     }

//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [FormData?.Quantity_Per_Box, FormData?.No_Of_Boxes]);

//   useEffect(() => {
//     if (FormData?.No_Of_Boxes && FormData?.Weight) {
//       let res = FormData?.No_Of_Boxes * FormData?.Weight;
//       updateSingleField(formRef, "Actual_Weight", res.toFixed(2));
//     } else {
//       updateSingleField(formRef, "Actual_Weight", null);
//     }

//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [FormData?.No_Of_Boxes, FormData?.Weight]);

//   useEffect(() => {
//     if (FormData?.Volumetric_Weight || FormData?.Actual_Weight) {
//       let res = 0;
//       const volumetricWeight = Number(FormData?.Volumetric_Weight ?? 0);
//       const actualWeight = Number(FormData?.Actual_Weight ?? 0);
//       if (volumetricWeight > actualWeight) {
//         res = volumetricWeight;
//       } else {
//         res = actualWeight;
//       }
//       updateSingleField(formRef, "Charge_Weight", res);
//     } else {
//       updateSingleField(formRef, "Charge_Weight", null);
//     }

//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [FormData?.Volumetric_Weight, FormData?.Actual_Weight]);

//   useEffect(() => {
//     if (FormData?.Rate && FormData?.Freight_On) {
//       if (FormData?.Rate && FormData?.Freight_On) {
//         let total = 0;
//         if (FormData?.Freight_On === "Weight") {
//           total = Number(FormData?.Charge_Weight) * Number(FormData?.Rate);
//         } else if (FormData?.Freight_On === "Quantity") {
//           total = Number(FormData?.Total_Quantity) * Number(FormData?.Rate);
//         } else if (FormData?.Freight_On === "Per Box") {
//           total = Number(FormData?.No_Of_Boxes) * Number(FormData?.Rate);
//         } else if (FormData?.Freight_On === "Fixed") {
//           total = Number(FormData?.Rate);
//         }
//         updateSingleField(formRef, "Freight_Amount", Number(total.toFixed(2)));
//       }
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [
//     FormData?.No_Of_Boxes,
//     FormData?.Freight_On,
//     FormData?.Rate,
//     FormData?.Charge_Weight,
//     FormData?.Rate,
//     FormData?.Total_Quantity,
//   ]);

//   const handleErrorsChange = (newErrors) => {
//     setFormErrors((currentErrors) => ({
//       ...currentErrors,
//       ...newErrors,
//     }));
//   };

//   const HanldeChangeonForm = (values) => {
//     setFormdata((prev) => ({
//       ...prev,
//       ...values,
//     }));
//   };

//   // Function to handle keyboard events
//   const handleKeyDown = (event) => {
//     if (getTopModal() === Form_Key) {
//       if (event.key === "Escape") {
//         Closeformfunction2();
//       } else if (event.key === "F4") {
//         Validate_handleSubmit(submit);
//       }
//     }
//   };

//   // Use the useEventListener hook from usehooks-ts to listen for keydown events
//   useEventListener("keydown", handleKeyDown);

//   let submit = () => {
//     if (String(index)) {
//       delete FormData?.Sidebyside;
//       setItems(
//         {
//           ...FormData,
//           _id: editData?._id ? editData?._id : "",
//           Content: String(FormData?.Content),
//           Packaging: String(FormData?.Packaging),
//           Quantity_Per_Box: FormData?.Quantity_Per_Box ? FormData?.Quantity_Per_Box : 0,
//           Volumetric_Weight: FormData?.Volumetric_Weight ? Number(FormData?.Volumetric_Weight) : "",
//           Actual_Weight: FormData?.Actual_Weight ? Number(FormData?.Actual_Weight) : "",
//           Charge_Weight: FormData?.Charge_Weight ? FormData?.Charge_Weight : "",
//         },
//         index
//       );
//       Closeformfunction2();
//     } else {
//       delete FormData?.Sidebyside;
//       setItems({
//         ...FormData,
//         _id: editData?._id ? editData?._id : "",
//         Content: String(FormData?.Content),
//         Packaging: String(FormData?.Packaging),
//         Quantity_Per_Box: FormData?.Quantity_Per_Box ? FormData?.Quantity_Per_Box : 0,
//         Volumetric_Weight: FormData?.Volumetric_Weight ? Number(FormData?.Volumetric_Weight) : "",
//         Actual_Weight: FormData?.Actual_Weight ? Number(FormData?.Actual_Weight) : "",
//         Charge_Weight: FormData?.Charge_Weight ? FormData?.Charge_Weight : "",
//       });
//       Closeformfunction2();
//     }
//   };

//   const Validate_handleSubmit = (submit) => {
//     const Error = checkFormErrors(formErrors);
//     if (!Error) {
//       submit();
//     }
//   };

//   return (
//     <Reactportal open={openItems} onClose={Closeformfunction2} TypeOfPortal={replaceUnderscore(Form_Key)}>
//       <div className="AddItem">
//         <div className="formcontainer">
//           {itemConfig?.AddMeterialItems &&
//             itemConfig?.AddMeterialItems.map((e) => {
//               return (
//                 <div key={e.id} className="">
//                   <div className="sectionHeadings">{replaceUnderscore(e.name)}</div>
//                   <div className="formSection insidecontainer">
//                     <FormInputSectionComponent
//                       inputfields={e.fields}
//                       Type={e.name}
//                       onhandleFormikChange={HanldeChangeonForm}
//                       validation_Schema={e?.Valid_schema}
//                       onErrorsChange={(newErrors) => handleErrorsChange(newErrors)}
//                       formkey={Form_Key}
//                       formRef={formRef}
//                     />
//                   </div>
//                 </div>
//               );
//             })}
//         </div>
//       </div>
//       {/* <div className="AddItem">
//         {itemConfig?.AddMeterialItems.map((e, i) => {
//           return (
//             <div key={e.id} style={{ margin: "10px" }} className="AddMeterialsDiv">
//               <AddMeterialDetails
//                 inputfields={e.fields}
//                 Type={e.name}
//                 handleErrorsChange={handleErrorsChange}
//                 fielddata={allFieldsData}
//                 TypeOfPortal={"AddItems"}
//                 Form_Key={Form_Key}
//               />
//             </div>
//           );
//         })}
//       </div> */}

//       <PortalFooter
//         renderContent={() => <></>}
//         disabled={false}
//         submitform={() => {
//           Validate_handleSubmit(submit);
//         }}
//         submitType={""}
//         SaveAndClose={() => {
//           Validate_handleSubmit(() => {
//             submit();
//           });
//         }}
//         handleformclose={() => {
//           Closeformfunction2();
//           setOpenItems(false);
//         }}
//       />
//     </Reactportal>
//   );
// };


//  useEffect(() => {
//     if (FormData?.Box_Dimension && FormData?.Inc_CMS === "in" && isFirstLoad) {
//       let parts = FormData.Box_Dimension.split("x");
//       if (parts?.includes("")) {
//         updateSingleField(formRef, "CFT", "");
//       } else {
//         let numerator = parts.reduce((acc, part) => {
//           return acc * Number(part);
//         }, 1);
//         let denominator = 12 * 12 * 12;
//         let res = numerator / denominator;
//         updateSingleField(formRef, "CFT", res.toFixed(2));
//       }
//     } else if (FormData?.Box_Dimension && FormData?.Inc_CMS === "cm" && isFirstLoad) {
//       let parts = FormData.Box_Dimension.split("x");
//       if (parts?.includes("")) {
//         updateSingleField(formRef, "CFT", "");
//       } else {
//         let numerator = parts.reduce((acc, part) => {
//           return acc * Number(part);
//         }, 1);
//         let res = numerator * 0.0000353147;
//         updateSingleField(formRef, "CFT", res.toFixed(2));
//       }
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [FormData?.Inc_CMS, FormData?.Box_Dimension]);